export default {
      id: "chevron-carousel-right-usage",
      viewBox: "0 0 8 15",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#chevron-carousel-right",
      toString: function () {
        return this.url;
      }
    }